import { useCallback, useMemo } from 'react';

import { insertItem } from './internal/insertItem';
import { parseData } from './internal/parseData';
import { serializeData } from './internal/serializeData';
import { useRecentProjectStorage } from './internal/useRecentProjectStorage';

export function useRecentProjectKeys() {
  const [json, slot] = useRecentProjectStorage();
  const items = useMemo(() => parseData(json), [json]);

  const append = useCallback(
    (key: string) => {
      const result = insertItem(items, key);
      slot.set(serializeData(result));
    },
    [items, slot],
  );

  return [items, append] as const;
}
